import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material'
import Cancel from './../../../../assets/icons/close.png'

import doc from './../../../../assets/images/LogoTransparent.png'

import { Girl } from '@mui/icons-material';

import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function RestaurantDetailsDialog(props) {
    const handleClose = () => {
        props.onClose(false)
    }
    const onClickSave = () => {


    }
    const apiAddress = process.env.REACT_APP_SECRET;

    const approvedData = async () => {
        var ids = [];
        ids.push(props.restaurantName.id);
        axios({
            method: 'put',
            url: apiAddress + '/api/NewRestaturantRequest/updateRestaurantRequests/1',
            data: ids
        })
            .then(function (response) {
                console.log(response);
                toast.success("Successfully Saved", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                // loadData();
                props.onClose(false)
            })
            .catch(function (error) {
                console.log(error);
                toast.error("Error" + error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
    }

    return (
        <div>
            <ToastContainer />
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth='lg'
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={6}>
                            <DialogTitle>{props.restaurantName.companyLegalName} details</DialogTitle>
                        </Grid>
                        <Grid item xs={6}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <div>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Restaurant Name
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Restaurant Name"
                                        value={props.restaurantName.companyLegalName}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Address
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Address"
                                        value={props.restaurantName.address}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Company Registration Number
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Company Registration Number"
                                        value={props.restaurantName.companyRegistrationNumber}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Business Type
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Business Type"
                                        value={props.restaurantName.businessTypeDescription}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Applied By
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Name"
                                        value={props.restaurantName.firstName}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Contact Number
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Contact Number"
                                        value={props.restaurantName.phoneNumber}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Email
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Email"
                                        value={props.restaurantName.email}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Website Address
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Website Address"
                                        value={props.restaurantName.webSiteAddress}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                                <Grid item xs={1} sx={{ paddingTop: '1.5rem', alignItems: "center" }}>

                                    <a href={props.restaurantName.webSiteAddress} target="_blank">Visit</a>
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Documents
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <a href={props.restaurantName.uploadedDocImagePath} target='blank'>document   </a>
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={12}>
                                    <div className='d-flex justify-content-end' style={{ gap: "10px" }}>
                                        {
                                            props.restaurantName.approvalStatusDescription == "Pending" ? (
                                                <button className='btn btn-success' onClick={() => { approvedData() }}>Approved</button>
                                            ) : ""
                                        }

                                        <button className='btn btn-danger' onClick={() => { handleClose() }}>Cancel</button>
                                    </div>
                                </Grid>


                            </Grid>


                        </div>
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        </div>
    );
}

export default RestaurantDetailsDialog;